<template>
     <div class="container-fluid">
         <div class="row">
            <div class="col-lg-8 col-md-12">
               <div class="card">
                  <div class="card-header d-flex justify-content-between">
                     <div class="header-title">
                        <h4 class="card-title">Add News</h4>
                     </div>
                  </div>
                  <div class="card-body">
                     <form>
                        <div class="form-group group mb-3 pb-1">
                           <label for="name"><bold class="asterik">*</bold>Name:</label>
                           <b-form-input style="width: 70%;" type="text" id="name" placeholder="Name" :class="`form-control ${$v.newsForm.name.$error ? 'is-invalid' : ''}`"
                              v-model="newsForm.name" @input="$v.newsForm.name.$touch()" @blur="$v.newsForm.name.$touch()" required>
                           </b-form-input>
                           <!-- <div class="invalid-feedback"><small>Required field</small></div> -->
                        </div>

                        <div class="form-group group mb-3 pb-1">
                           <label for="name">Game Code:</label>
                           <b-form-input style="width: 70%;" type="text" id="gameCode" placeholder="Game Code" v-model="newsForm.gameCode">
                           </b-form-input>
                        </div>
                        <div class="invalid-feedback"><small>Required field</small></div>

                        <div class="form-group mb-3 pb-1">
                           <label for="title"><bold class="asterik">*</bold>Title:</label>
                           <b-form-input type="text" id="title" placeholder="Title" :class="`form-control ${$v.newsForm.title.$error ? 'is-invalid' : ''}`"
                              v-model="newsForm.title" @input="$v.newsForm.title.$touch()" @blur="$v.newsForm.title.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="shortDesc"><bold class="asterik">*</bold>Short Description:</label>
                           <b-form-textarea id="shortDesc" placeholder="Short Desc." :class="`form-control ${$v.newsForm.shortDesc.$error ? 'is-invalid' : ''}`"
                              v-model="newsForm.shortDesc" @input="$v.newsForm.shortDesc.$touch()" @blur="$v.newsForm.shortDesc.$touch()" required>
                           </b-form-textarea>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="longDesc"><bold class="asterik">*</bold>Long Description:</label>
                           <b-form-textarea id="longDesc" placeholder="Long Desc." size="lg" :class="`form-control ${$v.newsForm.longDesc.$error ? 'is-invalid' : ''}`"
                              v-model="newsForm.longDesc" @input="$v.newsForm.longDesc.$touch()" @blur="$v.newsForm.longDesc.$touch()" required>
                           </b-form-textarea>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="image"><bold class="asterik">*</bold>Image</label>
                           <input type="file" name="image" style="width: 50%;" class="form-control-file" id="picture" :class="`form-control ${$v.newsForm.image.$error ? 'is-invalid' : ''}`"  @change="onFileChange">
                        </div>
                        <div class="invalid-feedback"><small>Required field</small></div>

                        <img v-bind:src="imagePreview" width="50%" style="margin-bottom: 35px;" v-show="showPreview"/>
                        <br>

                        <div class="form-group group mb-3 pb-1">
                           <label for="startDate"><bold class="asterik">*</bold>Start Date:</label>
                           <b-form-datepicker style="width: 70%;" id="startDate" v-model="newsForm.startDate" :class="`form-control ${$v.newsForm.startDate.$error ? 'is-invalid' : ''}`"
                              @input="$v.newsForm.startDate.$touch()" @blur="$v.newsForm.startDate.$touch()" required></b-form-datepicker>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group group mb-3 pb-1">
                           <label for="endDate"><bold class="asterik">*</bold>End Date:</label>
                           <b-form-datepicker style="width: 70%;" id="endDate" v-model="newsForm.endDate" :class="`form-control ${$v.newsForm.endDate.$error ? 'is-invalid' : ''}`"
                              @input="$v.newsForm.endDate.$touch()" @blur="$v.newsForm.endDate.$touch()" required></b-form-datepicker>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group group mb-3 pb-1">
                           <label for="category"><bold class="asterik">*</bold>Category:</label>
                           <b-form-select style= "width: 30% ; margin-left: 30px;" v-model="newsForm.category" :class="` ${$v.newsForm.category.$error ? 'is-invalid' : ''}`"
                              @input="$v.newsForm.category.$touch()" @blur="$v.newsForm.category.$touch()" :options="catOptions" required ></b-form-select>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>
                        <div class="form-group group mb-3 pb-1" v-if="newsForm.category != ''">
                           <label for="countdown"><bold class="asterik">* </bold>Type:</label>
                           <b-form-checkbox-group id="newsType" v-model="type"
                              :options="newsType" value-field="value"  required>
                           </b-form-checkbox-group>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group group mb-3 pb-1">
                           <label for="countdown"><bold class="asterik">* </bold>Countdown:</label>
                           <section :class="` ${$v.newsForm.countdown.$error ? 'is-invalid' : ''}`">
                              <input type="radio" v-model="newsForm.countdown" value="1"> Yes
                              <input type="radio" v-model="newsForm.countdown" value="0"> No
                           </section>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>                        
                     </form>

                     <div class="col-md-12 form-group">
                        <button type="button" class="btn btn-primary float-right" v-on:click="register">Add</button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
</template>
<style>
   .group {
      display: inline-block;
      width: calc(52% - 1.5em);
      padding-top: 20px;
   }
   .asterik{
      color:red
   }

  
</style>

<script>
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

const config = require("../../../../../config");
const constants = require("../../../../constants/CommonConstants");

Vue.use(VueAxios, axios)

export default {
   name:'NewsAdd',
   data() {
      return {
         newsForm: {
            name: '',
            title:'',
            shortDesc: '',
            longDesc: '',  
            imagename: '',
            image:'',
            category: [],
            startDate:'',
            endDate:'',
            countdown:'',
            createdBy:'',
            gameCode:''  
         },
         imagePreview: null,
         showPreview: false,
         catOptions: constants.newsCategory,
         countdown: constants.countdown,
         newsType: constants.newsType,
         type:[],
         cat:'',  
      }   
   },

   mixins: [validationMixin],
   validations: {
      newsForm: {  
         name: { required },
         title: { required },
         shortDesc: { required },
         longDesc: { required },
         category: { required },
         startDate:{ required },
         image: {required},
         endDate:{ required },
         countdown: {required}   
      }
   },
   
   methods: {
    register: async function() {
         try {
            this.$v.$touch();
            var user = JSON.parse(localStorage.getItem("user"));
      
            if(!this.$v.$invalid && confirm("Are you sure you want to save this news?")) {
               this.newsForm.createdBy = user.username
               var categories = []

               categories.push(this.newsForm.category)
   
               this.type.forEach(element => {
                  categories.push(element)
               });

               this.newsForm.category = categories.join();

               await axios.post(config.api.URL + '/api/news/add', this.newsForm, { params: { m: this.$route.meta.uid } });
               
               alert("news is added successfully.");
               this.$router.push({path: '/news/list'});
            }
         } catch(error) {
            alert("Error!")
            console.log("error", error)
         }
      },
      onFileChange(event){
         this.newsForm.image = event.target.files[0];
         this.newsForm.imagename = this.newsForm.image.name

         let reader  = new FileReader();
        
         let rawImg;
         reader.onloadend = () => {
            rawImg = reader.result;
            this.newsForm.image = rawImg
         }
         
         reader.addEventListener("load", function () {
            this.showPreview = true;
            this.imagePreview = reader.result;
         }.bind(this), false);

         if( this.newsForm.image ){
   
            if ( /\.(jpe?g|png|gif)$/i.test( this.newsForm.image.name ) ) {
               reader.readAsDataURL( this.newsForm.image);
            } else{
               alert("Invalid image format")
            }
         }
      }
   }
}
</script>